import React, { useState, useContext, useEffect } from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { ObjModal } from '../../../../contexts';
import { Typeahead } from 'react-bootstrap-typeahead';


const User = ( { label, db, value, ul, formId = 'gen' } ) => {
    const { setDraftValues } = useContext( ObjModal );
    const [ singleSelections, setSingleSelections ] = useState( [] );
    const [ loaded, setLoaded ] = useState( false );

    useEffect( () => {
        if ( value ) {
            const u = ul.find( f => f.uid === value );
            if ( u ) {
                setSingleSelections( [ u ] );
            }
        }
    }, [ value, ul ] );

    useEffect( () => {
        if ( loaded ) {
            let v;

            if ( singleSelections.length ) {
                const u = ul.find( f => f.uid === singleSelections[0].uid );
                if ( u ) {
                    v = u.uid;
                }
            }

            setDraftValues( prevState => (
                {
                    ...prevState,
                    [db]: v
                }
            ) );
        } else {
            // initial load has every value undefined - skip it
            setLoaded( true );
        }
    }, [ singleSelections, ul, db, setDraftValues, loaded ] );

    
    return (
        <Col className='tf-obj-data-element align-items-center'>
            <Form.Group as={Row} className='tf-form-group' controlId={`${formId}-${db}`}>
                <Form.Label column xs='auto' className='col-md-auto p-0 tf-form-label'>{label}</Form.Label>
                <Col className='tf-form-text-field me-1'>
                    <Typeahead
                        filterBy={ [ 'name', 'uid' ] }
                        id={`${formId}-${db}`}
                        labelKey={ ( option ) => `${option.name}` }
                        onChange={setSingleSelections}
                        selected={singleSelections}
                        options={ ul }
                        renderMenuItemChildren={ ( option ) => (
                            <div>
                                {option.name}
                            </div>
                        ) }
                        className='tf-typeahead-inline'
                    />
                </Col>
            </Form.Group>
        </Col>
    )
}

export default User;